import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"

const BASE_URL = "/user/company-defaults"

const PATHS = {
  companyDefaults: `${BASE_URL}/`
}

export interface CompanyDefaultsConfiguration {
  default_timezone: string
  default_working_days: string[]
  default_business_hours: { start?: string; end?: string }
}

type CompanyDefaultsPatch = Partial<CompanyDefaultsConfiguration>

export const getCompanyDefaults = (): Promise<
  ApiResponse<CompanyDefaultsConfiguration>
> => request.api.get(PATHS.companyDefaults)

export const updateCompanyDefaults = (
  payload: CompanyDefaultsPatch
): Promise<ApiResponse<CompanyDefaultsConfiguration>> =>
  request.api.patch(PATHS.companyDefaults, payload)
